import React from 'react'
import styled from 'styled-components';
import IndexContentContainer from "../../index/IndexContentContainer";
import RowSpacer from "../../../common/styles/RowSpacer";
import LoadingBar from "../../../common/LoadingBar";
import BooksitoutImages from "../../../images/BooksitoutImages";
import Spacer from "../../../common/Spacer";

const BookRecommenderListRowLoading: React.FC<{
    colorType: 'card' | 'card-card'
}> = ({colorType}) => {
    return (
        <IndexContentContainer backgroundColorType={colorType} isNotHover={true}>
            <Image src={BooksitoutImages.Placeholder.userLoading}/>

            <ContentContainer>

            <NameAndBadgeContainer>
                <NameContainer>
                    <LoadingBar size={5}/>
                </NameContainer>

                <Spacer/>

                <LoadingBar size={2}/>
            </NameAndBadgeContainer>

            <RowSpacer size={5}/>

            <Description><LoadingBar size={7}/></Description>
            </ContentContainer>
        </IndexContentContainer>
    )
}

const Image = styled.img`
    width: 60px;
    height: 60px;
    border-radius: 50%;
`

const Description = styled.p`
    margin: 0;
`

const ContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`

const NameAndBadgeContainer = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
`

const NameContainer = styled.div`
    display: flex;
    align-items: end;
`

export default BookRecommenderListRowLoading
